"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6.00012C5 4.93925 5.42143 3.92183 6.17157 3.17169C6.92172 2.42154 7.93913 2.00012 9 2.00012C10.0609 2.00012 11.0783 2.42154 11.8284 3.17169C12.5786 3.92183 13 4.93925 13 6.00012C13 7.06098 12.5786 8.0784 11.8284 8.82854C11.0783 9.57869 10.0609 10.0001 9 10.0001C7.93913 10.0001 6.92172 9.57869 6.17157 8.82854C5.42143 8.0784 5 7.06098 5 6.00012ZM12.824 10.6231C13.7755 9.83597 14.461 8.77441 14.7868 7.58328C15.1127 6.39215 15.0631 5.12949 14.6448 3.9676C14.2265 2.80571 13.4599 1.80118 12.4495 1.09111C11.4392 0.381036 10.2344 0 8.9995 0C7.7646 0 6.55978 0.381036 5.54946 1.09111C4.53913 1.80118 3.77251 2.80571 3.35421 3.9676C2.9359 5.12949 2.8863 6.39215 3.21217 7.58328C3.53803 8.77441 4.22349 9.83597 5.175 10.6231C1.986 11.7461 0 14.2471 0 17.0001C0 17.2653 0.105357 17.5197 0.292893 17.7072C0.48043 17.8948 0.734784 18.0001 1 18.0001C1.26522 18.0001 1.51957 17.8948 1.70711 17.7072C1.89464 17.5197 2 17.2653 2 17.0001C2 14.7301 4.355 12.0001 9 12.0001C13.645 12.0001 16 14.7301 16 17.0001C16 17.2653 16.1054 17.5197 16.2929 17.7072C16.4804 17.8948 16.7348 18.0001 17 18.0001C17.2652 18.0001 17.5196 17.8948 17.7071 17.7072C17.8946 17.5197 18 17.2653 18 17.0001C18 14.2471 16.016 11.7461 12.824 10.6231Z",
    fill: fill
  }));
};

exports["default"] = _default;